'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const RefreshIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="RefreshIcon">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.356995 5.17651L1.75049 7.25151L3.35299 5.33251"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.643 7.32746L10.2505 5.25146L8.647 7.17096"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.232 5.27002C10.4011 6.34166 10.1599 7.43766 9.55657 8.33933C8.95323 9.24099 8.03212 9.88202 6.97701 10.1345C6.27597 10.3008 5.54415 10.286 4.85042 10.0914C4.1567 9.8969 3.52387 9.52906 3.01151 9.02252"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.75251 7.23946C1.61098 6.67168 1.58344 6.08148 1.67147 5.50299C1.75949 4.9245 1.96134 4.3692 2.26534 3.86922C2.56934 3.36924 2.96946 2.93449 3.44254 2.59012C3.91563 2.24575 4.4523 1.9986 5.02151 1.86296C5.76984 1.68563 6.55228 1.71486 7.28531 1.94752C8.01833 2.18018 8.67441 2.60753 9.18351 3.18396"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

RefreshIcon.propTypes = {
  sx: PropTypes.object
}
